import React from 'react';
import './index.css';
const StateIcon = {
    approved: 'fa-check-circle',
    rejected: 'fa-times-circle',
    active: 'fa-circle',
    warning: 'fa-pause-circle',
    removed: 'fa-minus-circle',
    notApplicable: 'not-applicable-icon'
};
export const Tick = ({ style, disabled, state, id }) => {
    if (state === 'notApplicable') {
        return (React.createElement("div", { className: `${state} ${disabled ? 'disabled' : ''} tick`, id: id },
            React.createElement("img", { className: "not-applicable-icon", src: "assets/na.svg", style: style })));
    }
    const icon = state ? StateIcon[state] : 'fa-circle';
    return (React.createElement("div", { className: `${state ?? ''} ${disabled ? 'disabled' : ''} tick`, id: id },
        React.createElement("i", { className: `fas ${icon}`, style: { ...style } })));
};
